import cookie from 'js-cookie';

const __session__ = sessionStorage;

const TYPES = ['session', 'cookie'];
const DEFAULT_CACHE = TYPES[0];
let prefix = 'dfgw-';
const cache = {
  set: (key, value, type = DEFAULT_CACHE) => {
    !(type in TYPES) && (type = DEFAULT_CACHE);
    cache[type].set(prefix + key, value);
    return cache[type];
  },
  get: (key, type = DEFAULT_CACHE) => {
    !(type in TYPES) && (type = DEFAULT_CACHE);
    return cache[type].get(prefix + key);
  },
  clear: (type = DEFAULT_CACHE) => {
    !(type in TYPES) && (type = DEFAULT_CACHE);
    cache[prefix + type].clear();
    return cache[type];
  },
  remove: (key, type = DEFAULT_CACHE) => {
    cache[type].remove(prefix + key);
    return cache;
  },
  session: {
    set: (key, value) => {
      __session__.setItem(
        key,
        typeof value == 'string' ? value : JSON.stringify(value),
      );
      return cache.session;
    },
    get: (key, unFormat) => {
      let value = __session__.getItem(key);
      if (!unFormat) {
        return key && JSON.parse(value);
      } else {
        return value;
      }
    },
    remove: key => {
      __session__.removeItem(key);
      return cache.session;
    },
    clear: () => {
      __session__.clear();
      return cache.session;
    },
  },
  cookie: {
    // expire Day
    set: (key, value, expires = '', path = '/', domain) => {
      cookie.set(key, value, {
        expires,
        path,
        domain,
      });
      return cache.cookie;
    },
    get: key => cookie.get(key),
    remove: key => {
      cookie.remove(key);
      return cache.cookie;
    },
    clear: () => {
      cache.cookie.remove('dffl_ut_2');
      cache.cookie.remove('dffl_ut_test_2');
      cache.cookie.remove('mall_userId');
      cache.cookie.remove('Hm_lpvt_91e60d36b7b06785f72ce1797a6be307');
      cache.cookie.remove('Hm_lvt_91e60d36b7b06785f72ce1797a6be307');
      return cache.cookie;
    },
  },
};

export default cache;
